module.exports = __webpack_public_path__ + "img/garage-open.ccbcb534.svg";